<template>
  <v-app>
    <div id="pageStretcher">
      <v-scroll-y-transition>
        <DownloadAppContent
          @exit-modal="handleModalClose"
          v-if="isUserLogin && !isPwaInstalled && isDownloadAppModalOpen"
        />
      </v-scroll-y-transition>
      <TheHeader></TheHeader>
      <AlertPopup
        v-if="popups.length"
        @approve="approvePopUp"
        :popups="popups"
        :currPopup="currentPopup"
      />
      <div
        class="element-scroll"
        style="flex: 1"
        :style="{ height: $route.name === 'NotFound' ? '100%' : '' }"
      >
        <v-container
          fluid
          class="container"
          :class="{ RestLayout: $route.name === 'loginPage' }"
          :style="{
            padding:
              $route.name === 'loginPage' || $route.name === 'home'
                ? '0px'
                : '0px',
            height: $route.name === 'NotFound' ? '100%' : '',
          }"
        >
          <v-row
            :class="
              $route.name === 'Category' || $route.name === 'home'
                ? 'flex-row-reverse'
                : ''
            "
            :style="{
              height: $route.name === 'NotFound' ? '100%' : '',
            }"
          >
            <v-col
              v-if="$route.matched[0].meta?.sidebar"
              :class="[
                $route.name === 'loginPage' ? 'nav-login' : '',
                $route.name === 'Category' || $route.name === 'home'
                  ? 'side-bar-cart'
                  : '',
              ]"
              cols="12"
              md="7"
              xl="3"
              class="side-bar"
              :style="{
                'max-width': isDesktop ? '22%' : '100%',
              }"
            >
              <router-view name="sideBar"></router-view>
            </v-col>
            <v-slide-y-reverse-transition>
              <v-col class="mobile-side-bar" v-if="isOpenMobileSideBar">
                <router-view name="mobileSideBar"></router-view>
              </v-col>
            </v-slide-y-reverse-transition>
            <v-col
              class="main"
              :style="{
                'max-width':
                  isLaptop && $route.name === 'finances' ? '70%' : '',
                height: $route.name === 'NotFound' ? '100%' : '',
              }"
              :class="[
                isDesktop ? 'isDesktop' : '',
                isLaptop ? 'isLaptop' : '',
                isTablet ? 'isTablet' : '',
                isMobile ? 'isMobile' : '',
              ]"
            >
              <main
                v-if="isMainContentShowing"
                id="mainapp"
                :style="{
                  height: $route.name === 'NotFound' ? '100%' : '',
                  marginTop: $route.name === 'NotFound' ? '60px' : '',
                }"
              >
                <router-view :key="mainViewKey"></router-view>
                <a
                  :href="'https://wa.me/' + $store.getters['getWhatsappNum']"
                  target="_blank"
                >
                  <v-icon class="whatsapp-icon" icon="mdi-whatsapp"> </v-icon>
                </a>
              </main>
            </v-col>
          </v-row>
        </v-container>

        <router-view name="resetPassPage"></router-view>
      </div>
      <TheFooter></TheFooter>
      <Toast />
    </div>
    <LoginModel
      v-if="isLoginModelOpen"
      @close-login-model="setLoginModel(false)"
    />
    <InstallPwaBanner />
    <PushOptInBanner />
  </v-app>
</template>

<script>
import TheFooter from "./components/layout/TheFooter.vue";
import TheHeader from "./components/layout/TheHeader.vue";
import Toast from "./components/UI/Toast.vue";
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import LoginModel from "./components/UI/modals/Login/LoginModel.vue";
import AlertPopup from "./components/UI/PopUps/AlertPopup.vue";
import DownloadAppContent from "./components/menus/DownloadAppContent.vue";
import InstallPwaBanner from "./components/menus/InstallPwaBanner.vue";
import PushOptInBanner from "./components/menus/PushOptInBanner.vue";
import { getActiveListingPath } from "./utils/productModalNavigation";

export default {
  name: "App",
  components: {
    TheFooter,
    TheHeader,
    Toast,
    LoginModel,
    AlertPopup,
    DownloadAppContent,
    InstallPwaBanner,
    PushOptInBanner,
  },

  mounted() {
    document.getElementById("dolimo_loader").style.display = "none";
    this.setLang();
    this.startDownloadAppModalTimer();
  },
  computed: {
    ...mapGetters({
      isUserLogin: "AuthModule/isAuthenticated",
      getUserLang: "AuthModule/getUserLang",
      popups: "Alert/popupBycust",
      isMobile: "isMobile",
      isLaptop: "isLaptop",
      isTablet: "isTablet",
      isDesktop: "isDesktop",
      isPwaInstalled: "isPwaInstalled",
      isOpenMobileSideBar: "isOpenMobileSideBar",
      isLoginModelOpen: "AuthModule/isLoginModelOpen",
    }),
    isMainContentShowing() {
      if (this.$store.state.isMobile || this.$store.state.isTablet) {
        if (this.$store.state.openMenu) {
          return true;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    mainViewKey() {
      if (
        this.$route.name === "Products" ||
        this.$route.name === "CategoryProducts"
      ) {
        // Both routes render the same Products.vue instance; keep the key
        // stable while only the productId (product modal) changes, so
        // Vue Router reuses the instance instead of destroying/recreating
        // the listing behind the modal.
        return getActiveListingPath();
      }

      return this.$route.path;
    },
  },
  async created() {
    // console.log(isTablet);
    this.setScreenSizes();
    addEventListener("resize", () => {
      this.setScreenSizes();
      this.logOffAfterTime();
    });
    try {
      await this.$store.dispatch("getWebsiteSettings");
      await this.$store.dispatch("Category/getRootCategories");
      await this.$store.dispatch("Orders/getUserCart");
    } catch (err) {
      console.log(err);
    }
    // window.addEventListener("languagechange", function () {
    //   alert("languagechange event detected!");
    // });
  },
  unmounted() {
    window.removeEventListener("resize", () => {
      this.setScreenSizes();
      this.logOffAfterTime();
    });
    if (this.downloadAppModalTimer) {
      clearTimeout(this.downloadAppModalTimer);
    }
  },
  watch: {
    "$store.state.AuthModule.token": function () {
      this.setLang();
    },
    isUserLogin(newValue, oldValue) {
      // If user just logged out (was logged in, now not)
      if (oldValue === true && newValue === false) {
        sessionStorage.removeItem("downloadAppModalShown");
        console.log("Cleared download app modal session flag on logout");
      }

      // If user just logged in, start the timer
      if (newValue === true && oldValue === false) {
        this.startDownloadAppModalTimer();
      }
    },
  },
  methods: {
    startDownloadAppModalTimer() {
      // Check if modal was already shown in this session
      const modalShownThisSession = sessionStorage.getItem(
        "downloadAppModalShown",
      );

      // Only start timer if:
      // 1. User is logged in
      // 2. PWA is not installed
      // 3. Modal hasn't been shown this session
      if (this.isUserLogin && !this.isPwaInstalled && !modalShownThisSession) {
        // Clear any existing timer
        if (this.downloadAppModalTimer) {
          clearTimeout(this.downloadAppModalTimer);
        }

        this.downloadAppModalTimer = setTimeout(() => {
          this.isDownloadAppModalOpen = true;
          // Mark that modal has been shown in this session
          sessionStorage.setItem("downloadAppModalShown", "true");
        }, 60000); // 60 seconds = 1 minute

        // console.log("Download app modal will open in 1 minute");
      } else if (modalShownThisSession) {
        // console.log("Download app modal already shown this session");
      }
    },
    handleModalClose() {
      this.isDownloadAppModalOpen = false;
      // Ensure it's marked as shown when user closes it manually
      sessionStorage.setItem("downloadAppModalShown", "true");
    },
    logOffAfterTime() {
      if (this.isTablet || this.isMobile) {
        if (this.timerToAutoLogout) {
          clearTimeout(this.timerToAutoLogout);
        }
        this.$el.addEventListener("touchmove", () => {
          if (this.isUserLogin) {
            clearTimeout(this.timerToAutoLogoutMobile);
            this.timerToAutoLogoutMobile = setTimeout(() => {
              this.logout();
              this.$router.go(0);
            }, this.minute * 10);
          }
        });
      }

      if (!this.isTablet && !this.isMobile) {
        if (this.timerToAutoLogoutMobile) {
          clearTimeout(this.timerToAutoLogoutMobile);
        }
        this.$el.addEventListener("mousemove", () => {
          if (this.isUserLogin) {
            clearTimeout(this.timerToAutoLogout);
            this.timerToAutoLogout = setTimeout(() => {
              this.logout();
              this.$router.go(0);
            }, this.minute * 10);
          }
        });
      }
    },
    setLang() {
      if (this.isUserLogin) {
        this.$i18n.locale = this.getUserLang;
        document.dir = this.$i18n.messages[this.$i18n.locale].direction;
        document.documentElement.lang = this.$i18n.locale;
        this.$vuetify.locale.current = this.$i18n.locale;
      }
    },
    approvePopUp(alert) {
      this.$store.dispatch("Alert/approvePopUp", {
        alert,
        cust: this.userCust,
      });
    },
    setScreenSizes() {
      const width = window.innerWidth;
      this.$store.commit("setIsDesktop", width >= 1500);
      this.$store.commit("setIsLaptop", width >= 1025 && width < 1500);
      this.$store.commit("setIsTablet", width >= 602 && width < 1025);
      this.$store.commit("setIsMobile", width < 602);
    },
    ...mapActions({
      logout: "AuthModule/logout",
      setLoginModel: "AuthModule/setLoginModel",
    }),
  },
  data() {
    return {
      textfloat: "right",
      isDownloadAppModalOpen: false,
      timerToAutoLogoutDesktop: null,
      timerToAutoLogoutMobile: null,
      minute: 60000,
      currentPopup: 0,
      downloadAppModalTimer: null,
    };
  },
};
</script>

<style lang="scss">
.whatsapp-icon {
  position: fixed !important;
  bottom: 90px;
  right: 50px;
  font-size: 29px !important;
  background-color: #3e887e;
  color: white;
  z-index: 99;
  height: 50px !important;
  width: unset !important;
  aspect-ratio: 1/1;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 0 10px 2px #00000029;
}
#NagishLiTag {
  // display: none;
}
body nagishli#NagishLiTag > #NagishLiBar > #NagishLiBarStrip {
  padding: 5px !important;
}
.isMobile {
  .whatsapp-icon {
    bottom: 50px;
    right: 15px;
  }
}
@import "./assets/styles/materializeResets.scss";

@media only screen and (max-width: 601px) {
  .v-row {
    flex-direction: column-reverse !important;
  }
}
pre {
  // overflow-y: hidden !important;
  font-family: "Heebo";
  box-sizing: border-box;
}
body,
p,
h1,
h2,
h3,
h4,
h5 {
  margin: 0;
  overflow-x: hidden; //prevents top scroll
  font-family: "Heebo";
}
.mobile-side-bar {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  padding: 5px !important;
  background: white;
}
#mainapp {
  margin-top: 80px;
  //   max-width: 1600px !important;
  // margin: auto;
}
// כדי להוריד את layout
.RestLayout {
  max-width: unset !important;
  .main {
    padding: 0px !important;
    max-width: unset !important;
    flex: 1 0 !important;
  }
  #mainapp {
    margin: 0px !important;
  }
  .side-bar {
    position: relative !important;
    display: grid;
  }
}
.v-row {
  height: 100%;
}
.side-bar-cart {
  height: 100%;
  padding-bottom: 0px !important;
}
.main {
  height: 100%;
}
input:focus-visible {
  outline: none !important;
}

* {
  touch-action: manipulation;
}
.main-content-app,
.option-selected-conteiner {
  transition: 0.2s;
}

/* width */
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
::-webkit-scrollbar-button {
  height: 5%;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: linear-gradient(
    235.26deg,
    $primaryColor 0%,
    $primaryColor 40.5%,
    #cacaca 94%,
    #e0e0e0 100%
  );
  border-radius: 10px;
  min-height: 40px !important;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #b30000;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #5784ea;
}
.nav-login {
  top: 0px !important;
}

.toast {
  color: white !important;
}
.side-bar:lang(en),
.main:lang(en) {
  left: 0 !important;
}
.lang-container {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: end;
  .caret:lang(en) {
    left: unset !important;
    right: 0 !important;
  }
  .select-wrapper input.select-dropdown:focus {
    border: unset !important;
    margin: 0 !important;
  }
  .select-wrapper {
    width: 50px !important;
  }
  input {
    border: unset !important;
    margin: 0 !important;
  }
  svg {
    right: unset !important;
    left: 0;
  }
  ul {
    padding: 0;
    text-align: center;
    span {
      color: #1c1c1c !important;
    }
  }
}
@media (max-width: 601px) {
  .main-content-app,
  .option-selected-conteiner {
    transition: 0.2s;
  }
  // .footer {
  //   z-index: -3;
  // }
}

// .row .col {
//   float: var(--textfloat)
// }
/* Chrome, Safari, Edge, Opera hide arrow from number inputs*/
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox hide arrow from number inputs*/
input[type="number"] {
  -moz-appearance: textfield;
}

#pageStretcher {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.toast-container {
  bottom: 0 !important;
}

.toast {
  color: unset;

  &.success {
    background-color: #70b132;
  }

  &.error {
    background-color: rgb(240, 51, 51);
  }
}

main {
  // margin-top: 20px;
}
@media (min-width: 900px) {
  .side-bar {
    position: -webkit-sticky !important;
    position: sticky !important;
    top: 170px;
    height: calc(100vh - 207px);
    // max-width: 20% !important;
    padding-right: 0px !important;
    padding-left: 0px !important;
  }
  // .main {
  //   max-width: 78% !important;
  //   flex: 0 0 78% !important;
  // }
}

@media (min-width: 1044px) {
  .side-bar {
    // max-width: 25% !important;
  }
}

header {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 99999 !important;
  transition: 0.2s;
}

@media only screen and (max-width: 601px) {
  //mobile
  main {
    margin-top: unset;
    //  .main {
    // max-width: calc(100vw - 20px);
    // overflow-x: scroll;
    // }
  }
  //  .side-bar {
  //   position: -webkit-sticky !important;
  //   position: sticky !important;
  //   top: 112px;
  // }
}

[type="checkbox"].dolimo-style.filled-in:not(:checked)
  + span:not(.lever):after {
  border-radius: 7px;
  border: unset;
  box-shadow: 0 0 3px inset;
  right: 0;
}
[type="checkbox"].dolimo-style.filled-in:checked + span:not(.lever):after {
  border-radius: 7px;
  border: unset;
  background-color: $primaryColor;
  top: 3px;
  right: 0;
}

[type="checkbox"] + span:not(.lever) {
  padding: unset;
  padding-right: 35px;
}
[type="checkbox"] + span:not(.lever):lang(en) {
  padding-right: 0px;
  padding-left: 35px;
}
[type="checkbox"].filled-in:checked + span:not(.lever):before {
  left: unset;
  right: 10px;
}
[type="checkbox"].filled-in:checked + span:not(.lever):lang(en)::before {
  top: 2px;
  left: 0px;
}

.btn.dolimo-style {
  background-color: unset;
  background: $primaryBackgroundButtonColor;
  font-size: $mediumTextSize;
  color: white !important;
}

p {
  font-size: $mediumTextSize;
  color: $primaryTextColor;
}
html,
pre {
  // overflow-y: hidden !important;
  font-family: "Heebo";
  scroll-behavior: smooth;
  box-sizing: border-box;
  overflow: auto;
}
body {
  margin: 0;
  overflow-x: hidden; // prevents top scroll
  font-family: "Heebo";
}
input.dolimo-style {
  border: 1px solid lightgrey !important;
  border-radius: 10px !important;

  font-size: $smallTextSize !important;
  margin: 0 !important;

  padding-right: 10px !important;
}
input.dolimo-style:lang(en) {
  padding-right: 0px;
  padding-left: 10px !important;
}
textarea {
  padding: 10px !important;
}
.menu-collection {
  padding: 0 !important;
  border: unset !important;
  a {
    // color: #747474 !important;
    font-size: $mediumTextSize;
    border: unset !important;
    // border-radius: 8px;
    &.router-link-active {
      color: #73b235 !important;
      background-color: $primaryColorlight !important;
      // border-right: 5px solid $primaryColor !important;
    }
  }
}
input {
  max-width: 100% !important;
  box-sizing: border-box !important;
}

// @media only screen and (max-width: 1440px) {
//   .main.v-col {
//     max-width: 70% !important;
//   }
// }
</style>
